import LoadJSPartyEmbed from "../../../../src/components/LoadJSPartyEmbed";
import * as React from 'react';
export default {
  LoadJSPartyEmbed,
  React
};